import api from '../api/axios';
import { DocenteFicha, DocentePublico, SuperArea } from '../types/docente';

export const docenteService = {
  /** Profesores que ofrecen temas, con su correo y últimos temas. */
  list: async (params: { q?: string; superarea?: string }): Promise<DocentePublico[]> => {
    const { data } = await api.get<DocentePublico[]>('docentes/publicos/', { params });
    return data;
  },

  /** Ficha de un profesor: agrega sus áreas agrupadas por supercategoría. */
  ficha: async (rut: number): Promise<DocenteFicha> => {
    const { data } = await api.get<DocenteFicha>(`docentes/publicos/${rut}/`);
    return data;
  },

  /** Supercategorías con sus áreas (el filtro de la vista). */
  superareas: async (): Promise<SuperArea[]> => {
    const { data } = await api.get<SuperArea[]>('superareas/');
    return data;
  },
};
